export default [
  // 资讯详情
  {
    path: '/information-detail-:id',
    component: () => import('@/views/information/Detail.vue'),
    name: 'information-detail',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
